export default "__VITE_ASSET__Ddtw5AdQ__"